import {AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Observable, Subscription, timer} from 'rxjs';
import {AppDialogAddComponent} from '../../shared/components/app-dialog-add/app-dialog-add.component';
import {MatDialog, MatDialogConfig, MatDialogRef, MatSort} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {NavigationService} from '../../shared/services/navigation.service';
import {PartService} from '../../shared/services/part.service';
import {isNullOrUndefined} from 'util';
import {PartClass} from '../../shared/interfaces/part-class';
import {VehicleClass} from '../../shared/interfaces/vehicle-class';
import {EstanteriaClass} from '../../shared/interfaces/estanteria-class';
import {AppDialogSearchComponent} from '../../shared/components/app-dialog-search/app-dialog-search.component';
import {AppUtils} from '../../shared/helpers/app.utils';

@Component({
    selector: 'app-parts',
    templateUrl: './parts.component.html',
    styleUrls: ['./parts.component.scss']
})
export class PartsComponent implements OnInit, AfterViewInit, OnDestroy {
  // ID VEHÍCULO, MARCA, MODELO, AÑO, ESTANTERÍA, PIEZA Y COLOR
  displayedColumns: string[] = ['id','marcaDesc', 'modeloDesc', 'fichaAnyo', 'txtEstanteria', 'piezaDesc',  'actions'];
    dataSource: MatTableDataSource<any>;
    subsPart: Subscription;
    paginatorService: Subscription;
    loading = true;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @HostBinding('class.mobile') mobile;
    data: any[] = [];
    renderInit = false;
    public filter: Array<any> = [];
    public page = 1;
    public pageSize = 10;
    public pageIndex = 1;
    public pages = 1;
    public count = 0;
    public textSearch = '';

    get isMobile(): Observable<boolean> {
        return this.navigation.obsIsMobile;
    }

    dialogAdd: MatDialogRef<AppDialogAddComponent>;
    dialogSearch: MatDialogRef<AppDialogSearchComponent>;
  public currentUserData:any;
    constructor(public dialog: MatDialog, private partService: PartService, private navigation: NavigationService) {
        this.dataSource = new MatTableDataSource<any>(this.data);
      this.currentUserData = AppUtils.load('currentUserData');
        this.isMobile.subscribe(isMobile => {
            this.mobile = isMobile;
            //idVehicleDm
            if (this.mobile)
                this.displayedColumns = [ 'marcaDesc', 'modeloDesc', 'actions'];
            else
                this.displayedColumns = [ 'marcaDesc', 'modeloDesc', 'fichaAnyo', 'txtEstanteria', 'piezaDesc',  'actions'];
        });
    }

    ngOnDestroy(): void {
        this.subsPart.unsubscribe();
        this.paginatorService.unsubscribe();
    }

    ngOnInit() {
        this.dataSource.sort = this.sort;
        this.partService.loading.subscribe((load: boolean) => {
            this.loading = load;
        });
        this.subsPart = this.partService
            .parts
            .subscribe((items: any) => {
                    if (this.renderInit) {
                        this.data = items;
                        this.initialData();

                    }

                },
                error => {
                    this.loading = false;
                    this.data = [];

                });
        this.paginatorService = this.partService
            .paginator
            .subscribe((pagin: any) => {
                if (!isNullOrUndefined(pagin)) {
                    this.page = +pagin.pg;
                    this.pageSize = +pagin.pgSize;
                    this.count = +pagin.count;
                    this.pages = +pagin.pages;
                }
            });
        this.applyFilter();
        // this.partService.index();

    }


    ngAfterViewInit(): void {
        this.renderInit = true;
    }

    selectedRow(row) {
        console.log('ROW SELECTED ', row);
        this.showDialogAdd(row);
    }

    public paginatorChange(ev) {
        this.page = ev.pageIndex + 1;
        this.pageSize = ev.pageSize;
        this.applyFilter();
    }

    txtFilter() {
        this.filter = [{'property': 'descripcion', 'operator': 'LIKE', 'value': this.textSearch}];
        this.applyFilter(this.filter);
    }

    public applyFilter(filter: Array<any> = null, page: number = this.page, pageSize: number = this.pageSize) {

        this.partService.index(true, page, pageSize, filter);
    }

    public initialData() {
        this.dataSource = new MatTableDataSource<any>(this.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const subscribe = timer(200).subscribe(val => this.loading = false);

    }

    public showDialogAdd(entity: PartClass = new PartClass(), formDisable: boolean = false) {
        const config = new MatDialogConfig();
        config.width = (this.mobile) ? '100%' : '65%';
        config.height = (this.mobile) ? '100%' : '85%';
        this.dialogAdd = this.dialog.open(AppDialogAddComponent, config);
        this.dialogAdd.componentInstance.entity = entity;
        this.dialogAdd.componentInstance.formDisable = formDisable;
        this.dialogAdd.afterClosed().subscribe(result => {
            if (result)
                this.partService.index();
        });
    }

    public showDialogFilter(entity: PartClass = new PartClass()) {
        const config = new MatDialogConfig();
        config.width = ( this.mobile) ? '100%' : '50%';
        config.height = ( this.mobile) ? '100%' : '80%';
        config.height = ( entity instanceof EstanteriaClass) ? 'auto' : config.height;
        this.dialogSearch = this.dialog.open(AppDialogSearchComponent, config);
        this.dialogSearch.componentInstance.entity = entity;
        this.dialogSearch.afterClosed().subscribe(result => {
            // if(result )
            //     this.navigateToRoute(entity);

        });
    }

    btnAction(ev) {
        if (ev === 'add')
            this.showDialogAdd();
    }
}
